import { muiGlyph } from "@/components/ui/mui-glyph";

// MUI's three checkbox glyphs, as `@mui/material` 9.2.0 draws them
// (`internal/svg-icons/{CheckBoxOutlineBlank,CheckBox,IndeterminateCheckBox}.js`)
// — the icons `Checkbox.js` swaps between for its unchecked, checked and
// `indeterminate` states, each at `fontSize='small'` (20px) for a
// `size='small'` checkbox.
//
// For surfaces where the checkbox is **a picture of the state rather than a
// control**: a list row that is itself the `option` or `checkbox`, where a
// second focusable box inside it would be invalid ARIA and a second stop in the
// reading order (`MuiCheckboxList`). A real control composes `CheckboxField`.

const CHECK_BOX_OUTLINE_BLANK_PATH =
  "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z";
const CHECK_BOX_PATH =
  "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z";
const INDETERMINATE_CHECK_BOX_PATH =
  "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z";

export const MuiCheckBoxOutlineBlankSmallIcon = muiGlyph(
  "mui-check-box-outline-blank",
  CHECK_BOX_OUTLINE_BLANK_PATH,
  "size-5",
);
export const MuiCheckBoxSmallIcon = muiGlyph("mui-check-box", CHECK_BOX_PATH, "size-5");
export const MuiIndeterminateCheckBoxSmallIcon = muiGlyph(
  "mui-indeterminate-check-box",
  INDETERMINATE_CHECK_BOX_PATH,
  "size-5",
);

// The same two glyphs at MUI's default `fontSize='medium'` (24px), for an
// unsized `Checkbox`: `CheckboxField size="medium"` draws them over its control
// (#755).
export const MuiCheckBoxOutlineBlankIcon = muiGlyph(
  "mui-check-box-outline-blank",
  CHECK_BOX_OUTLINE_BLANK_PATH,
  "size-6",
);
export const MuiCheckBoxIcon = muiGlyph("mui-check-box", CHECK_BOX_PATH, "size-6");
